import { render, staticRenderFns } from "./entregas.vue?vue&type=template&id=4b56a0ce&scoped=true"
import script from "./entregas.vue?vue&type=script&lang=js"
export * from "./entregas.vue?vue&type=script&lang=js"
import style0 from "./entregas.vue?vue&type=style&index=0&id=4b56a0ce&prod&lang=scss"
import style1 from "./entregas.vue?vue&type=style&index=1&id=4b56a0ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b56a0ce",
  null
  
)

export default component.exports